<template>
    <AppHeader/>
    <MenuBar/>
    <SearchContent/>
    <BottomFooter/>
</template>

<script>
import AppHeader from '@/components/header/Header.vue'
import MenuBar from '@/components/menu-bar/MenuBar.vue'
import SearchContent from '@/components/search/SearchContent.vue'
import BottomFooter from '@/components/footer/Footer.vue'

export default {
    components: {
        AppHeader,
        MenuBar,
        SearchContent,
        BottomFooter
    }
}
</script>